import {UIModeSelectorDetailsController, StartGameCallback} from '../../../../../../shared/scripts/ui_html/home_page/UIModeSelectorDetailsController'

export class UIMModeSelectorDetailsController extends UIModeSelectorDetailsController {
    constructor(onStartGame: StartGameCallback) {
        super(onStartGame)
        this.detailsContainer.classList.add('mm-details-mobile')
    }
}

